export default "/packs/images/bookmark-outline~71c3aed96ea93529f6bdb07a53321d47.svg";